var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.681,
    height: 19.259,
    viewBox: "0 0 22.681 19.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-403.252 -363.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_36",
    "data-name": "\\u30D1\\u30B9 36",
    d: "M424.217,364.063v5.478h5.478",
    transform: "translate(-11.335)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_37",
    "data-name": "\\u30D1\\u30B9 37",
    d: "M419.242,386.575h-7.3",
    transform: "translate(-4.534 -12.469)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_38",
    "data-name": "\\u30D1\\u30B9 38",
    d: "M419.242,394.761h-7.3",
    transform: "translate(-4.534 -17.003)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_39",
    "data-name": "\\u30D1\\u30B9 39",
    d: "M413.764,378.389h-1.826",
    transform: "translate(-4.534 -7.935)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_44",
    "data-name": "\\u30D1\\u30B9 44",
    d: "M436.1,388.871",
    transform: "translate(-17.918 -13.741)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_45",
    "data-name": "\\u30D1\\u30B9 45",
    d: "M436.5,391.706",
    transform: "translate(-18.136 -15.311)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_46",
    "data-name": "\\u30D1\\u30B9 46",
    d: "M418.36,371.5v-1.954l-5.478-5.478h-7.3a1.826,1.826,0,0,0-1.826,1.826V380.5a1.826,1.826,0,0,0,1.826,1.826h10.956a1.826,1.826,0,0,0,1.826-1.826v-1.5",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_47",
    "data-name": "\\u30D1\\u30B9 47",
    d: "M442.427,373.518h0l-3.7,4.026,1.975,1.975,4.026-3.7A1.632,1.632,0,1,0,442.427,373.518Z",
    transform: "translate(-19.374 -4.92)",
    fill: "#4477c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_48",
    "data-name": "\\u30D1\\u30B9 48",
    d: "M433.6,384.251l-.535.211-1.162.457a.645.645,0,0,0-.409.408L430.31,388.9l.095.1,1.875-1.875a.631.631,0,0,1-.032-.158.646.646,0,1,1,.822.619.657.657,0,0,1-.176.027h0a.61.61,0,0,1-.157-.032l-1.875,1.875.094.095,2.114-.7,1.455-.485a.646.646,0,0,0,.409-.409l.667-1.7Z",
    transform: "translate(-14.71 -11.182)",
    fill: "#4477c0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconDoc);
export default __webpack_public_path__ + "static/media/nav-icon-doc.5a4682895880406557507ab6211c9e1d.svg";
export { ForwardRef as ReactComponent };